import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogAddRfidCardView from '../DialogAddRfidCardView';
import ChargeRfidListFilterView from './components/ChargeRfidListFilterView';
import ButtonFilterDropdown from 'general/components/quybka/Buttons/ButtonFilterDropdown';
import AppConstants from 'general/constants/AppConstants';

ChargeRfidListView.propTypes = {};

const defaultColumnIds = ['ID_TAG', 'OPERATOR', 'PLATE', 'VEHICLE_BRAND', 'VEHICLE_MODEL', 'DRIVER', 'SERIAL', 'STATUS'];

function ChargeRfidListView(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { operatorList } = useAgency();
  const { user, permissionList } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeRfidList);
  const [chargeRfidList, setChargeRfidList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    const params = _.pickBy(
      filter,
      (value) => value !== null && value !== undefined && value !== ''
    );
    ChargeHelper.API.RFID.requestGetRFIDCardList(params)
      .then((response) => {
        setChargeRfidList(response?.chargeRFIDs);
        setTotal(response?.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter]);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'ID_TAG',
        name: UIHelper.buildTableColumn('Mã ID Tag'),
        selector: (row) => row?.idTag,
        minWidth: '240px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'OPERATOR',
        name: UIHelper.buildTableColumn('Nhà điều hành'),
        selector: (row) => (
          <span className="cursor-pointer hover-opacity-60">
            {_.find(operatorList, (item) => item.operatorId === row?.operatorId)?.name}
          </span>
        ),
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_BRAND',
        name: UIHelper.buildTableColumn('Hãng xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.manageVehicleBrand}/${row?.vehicle?.model?.brand?.brandId}`);
            }}
          >
            {row?.vehicle?.model?.brand?.name}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        id: 'VEHICLE_MODEL',
        name: UIHelper.buildTableColumn('Dòng xe'),
        selector: (row) => row?.vehicle?.model?.name,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PLATE',
        name: UIHelper.buildTableColumn('Biển số'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.vehicleList}/${row?.vehicle?.vehicleId}`);
            }}
          >
            {row?.vehicle?.plate}
          </span>
        ),
        minWidth: '160px',
        style: tableStyle.columns.link,
      },
      {
        id: 'DRIVER',
        name: UIHelper.buildTableColumn('Tên khách hàng'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.customerDetail}/${row?.vehicle?.userId}`);
            }}
          >
            {row?.vehicle?.user?.fullname}
          </span>
        ),
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'SERIAL',
        name: UIHelper.buildTableColumn('Số serial nạp tiền'),
        selector: (row) => row?.serialNumber,
        minWidth: '150px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái'),
        selector: (row) => (
          <KTLabel
            text={ChargeHelper.Utils.getRFIDCardStatusName(row?.status)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${ChargeHelper.Utils.getRFIDCardStatusColor(
              row?.status
            )}`}
          />
        ),
        minWidth: '160px',
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, [operatorList]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const windowSize = useWindowSize();
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
    saveChanges,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    if (isAdmin) {
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.rfidCardUpdate.code)) {
        // chinh sua
        actions.push({
          text: 'Chỉnh sửa',
          iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleAddNew(row);
          },
        });
        if (row?.status === ChargeConstants.RFIDCardStatus.NORMAL) {
          if (!Utils.isValid(row?.vehicleId)) {
            actions.push({
              text: 'Gán thẻ',
              iconElement: <i className="fa-regular fa-hashtag" style={{ fontSize: '1.1rem' }} />,
              click: () => {
                AppCustomDialogHelper.show(
                  '',
                  <AgencySaleDialogView
                    title="Gán thẻ RFID"
                    iconEl={<img src={AppResource.images.dialogIcons.dialogProvideCard} />}
                    contentEl={<>Chọn xe cần gán và nhấn xác nhận để hoàn thành.</>}
                    removeFooter={true}
                    bodyEl={
                      <DialogAddRfidCardView
                        item={row}
                        taggingMode={true}
                        onCancel={() => AppCustomDialogHelper.hide()}
                        onDone={() => {
                          AppCustomDialogHelper.hide();
                          handleRefresh();
                        }}
                      />
                    }
                  />,
                  'md',
                  false,
                  true
                );
              },
            });
          } else {
            actions.push({
              text: 'Thu hồi',
              iconElement: <i className="fa-regular fa-recycle" style={{ fontSize: '1.1rem' }} />,
              click: () => {
                ChargeHelper.UI.RFID.showDialogConfirmRevokeRFID(row, () => {
                  handleRefresh();
                });
              },
            });
          }
          actions.push({
            text: 'Khoá thẻ',
            iconElement: <i className="fa-regular fa-lock" style={{ fontSize: '1.1rem' }} />,
            click: () => {
              ChargeHelper.UI.RFID.showDialogConfirmLockRFID(row, () => {
                handleRefresh();
              });
            },
          });
        } else {
          actions.push({
            text: 'Khôi phục',
            iconElement: <i className="fa-regular fa-play" style={{ fontSize: '1.1rem' }} />,
            click: () => {
              ChargeHelper.UI.RFID.showDialogConfirmRestoreRFID(row, () => {
                handleRefresh();
              });
            },
          });
        }
      }
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.rfidCardDelete.code)) {
        // xoa
        actions.push({
          text: 'Xoá thẻ',
          iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleDelete(row);
          },
        });
      }
    }
    return actions;
  };

  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeRfidList });
  };
  const handleDelete = (row) => {
    ChargeHelper.UI.RFID.showDialogConfirmDeleteRFID(row, () => {
      handleRefresh();
    });
  };
  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Sửa thẻ RFID' : 'Thêm thẻ RFID',
      <DialogAddRfidCardView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'md',
      false,
      true
    );
  };

  return (
    <div>
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
            {/* title */}
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Danh sách thẻ RFID
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                Tổng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                  {Utils.formatNumber(total)} thẻ
                </span>
              </span>
            </div>

            {/* actions */}
            {isAdmin && Utils.checkPermission(permissionList, AppConstants.permissionCode.rfidCardCreate.code) &&
              UIHelper.buildGreenButton(
                'Thêm mới',
                handleAddNew,
                <i className="fa-regular fa-circle-plus" />
              )}
          </div>

          {/* table */}
          <div className="">
            {/* filter */}
            <div className="row m-0 p-0 px-2">
              {/* tim kiem */}
              {windowSize.width >= 768 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Tìm kiếm')}
                  <KTFormSearch
                    name="search"
                    placeholder="Theo mã ID tag, số serial nạp tiền..."
                    value={filter.q}
                    onSubmit={(text) => {
                      ChargeHelper.Filter.chargeRfidList = {
                        ...ChargeHelper.Filter.chargeRfidList,
                        q: text,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                  />
                </div>
              )}
              {/* loc theo trang thai */}
              {windowSize.width >= 1120 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Trạng thái')}
                  <KTBSDropdown
                    name="status"
                    toggleElement={
                      <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                      >
                        {_.find(
                          ChargeHelper.Data.chargeRfidStatusOptions,
                          (item) => item.value === ChargeHelper.Filter.chargeRfidList?.status
                        )?.name ?? 'Tất cả'}
                      </button>
                    }
                    selectedValue={ChargeHelper.Filter.chargeRfidList?.status}
                    dropdownMenuItems={[
                      { name: 'Tất cả', value: '' },
                      ...ChargeHelper.Data.chargeRfidStatusOptions,
                    ]}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                      ChargeHelper.Filter.chargeRfidList = {
                        ...ChargeHelper.Filter.chargeRfidList,
                        status: value,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                    isDropdownForm={true}
                  />
                </div>
              )}
              {/* thiet lap cot */}
              <div className="col mb-4 px-2 d-flex align-items-end gap-3">
                {/* bo loc */}
                {/* <ButtonFilterDropdown
                  dropdownContent={
                    <ChargeRfidListFilterView
                      onCancel={() => {
                        handleRefresh();
                      }}
                      onApply={() => {
                        handleRefresh();
                      }}
                    />
                  }
                />
                <DropdownTableConfigColumn
                  columnIds={columnIds}
                  fullColumns={fullColumns}
                  fullColumnIds={fullColumnsIdSorted}
                  onChangeCheckboxValue={onChangeCheckboxValue}
                  resetDefaultTableColumn={resetDefaultTableColumn}
                  onChangeFullColumnIds={(ids) => {
                    setFullColumnIds(ids);
                    const key = prefKey + '_FULL_COLUMN_IDS';
                    localStorage.setItem(key, ids.join('|'));
                  }}
                  onSelectAll={onSelectAll}
                  onUnSelectAll={onUnSelectAll}
                  saveChanges={saveChanges}
                /> */}
              </div>
            </div>

            <div className="px-4">
              <KTTable
                columns={columns}
                items={chargeRfidList}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={UIHelper.buildEmptyNoData(
                  'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                )}
              />
            </div>
          </div>

          {/* pagination */}
          <div className="px-4 mt-2">
            <KTPagination
              currentPage={filter.page + 1}
              rowCount={total}
              rowsPerPage={filter.limit}
              currentItemInPageCount={chargeRfidList?.length}
              onChangePage={(newPage) => {
                const iNewPage = parseInt(newPage);
                ChargeHelper.Filter.chargeRfidList = {
                  ...ChargeHelper.Filter.chargeRfidList,
                  page: iNewPage - 1,
                };
                handleRefresh();
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                const iNewRowsPerPage = parseInt(newRowsPerPage);
                ChargeHelper.Filter.chargeRfidList = {
                  ...ChargeHelper.Filter.chargeRfidList,
                  limit: iNewRowsPerPage,
                  page: 0,
                };
                handleRefresh();
              }}
              loading={false}
              color={KTPaginationColor.success}
              appendText="thẻ"
            />
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default ChargeRfidListView;
